import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import getSidebarQualities from 'selectors/myself/getSidebarQualities';
import getEchoes from 'selectors/myself/getEchoes';
import AccessibleMapMenu from './AccessibleMapMenu';
import AccessibleNavigationTabs from './AccessibleNavigationTabs';
import { IAppState } from 'types/app';

export function AccessibleSidebarContainer({
  actionBankSize,
  actions,
  currentAreaName,
  echoes,
  name,
  nextActionAt,
  sidebarQualities,
}: Props) {
  const fetching = [
    actionBankSize,
    currentAreaName,
    echoes,
    name,
    nextActionAt,
  ].some(x => !x);
  if (fetching) {
    return (
      <div className="accessible-sidebar u-visually-hidden">
        Fetching stats.
      </div>
    );
  }

  const formattedNextActionAt = moment(new Date(nextActionAt)).format('hh:mm');
  return (
    <div id="accessible-sidebar" className="accessible-sidebar u-visually-hidden">
      <section className="welcome">
        {`It's ${name}!`}
        {' '}
        {`Welcome to ${currentAreaName}, delicious friend!`}
      </section>
      <section className="accessible-map">
        <AccessibleMapMenu />
      </section>
      <section className="site-navigation">
        <AccessibleNavigationTabs />
      </section>
      <section className="player-actions">
        {`Actions: ${actions} of ${actionBankSize}`}
        {' '}
        <time dateTime={formattedNextActionAt}>
          {`Next actions at ${formattedNextActionAt}`}
        </time>
      </section>
      <section className="player-echoes">
        {`Echoes: ${echoes.toFixed(2)}`}
      </section>
      <ul className="sidebar-qualities">
        {sidebarQualities.map(quality => (
          <li key={quality.id} className={quality.category}>
            {quality.name}
            :
            {' '}
            {quality.effectiveLevel}
          </li>
        ))}
      </ul>
    </div>
  );
}

AccessibleSidebarContainer.displayName = 'AccessibleSidebarContainer';

interface Props {
  actions: number,
  actionBankSize: number,
  currentAreaName?: string,
  echoes: number,
  name?: string,
  nextActionAt: any,
  sidebarQualities: any[],
}

const mapStateToProps = (state: IAppState) => {
  const {
    actions: { actions, actionBankSize },
    map: { currentArea },
    myself: { character: { name } },
    timer: { timeNextActionIsAvailable: nextActionAt },
  } = state;
  return {
    actions,
    actionBankSize,
    currentAreaName: currentArea?.name,
    name,
    nextActionAt,
    echoes: getEchoes(state),
    sidebarQualities: getSidebarQualities(state),
  };
};

export default connect(mapStateToProps)(AccessibleSidebarContainer);